import HomeIconV2 from "app/components/Icons/HomeIconV2";
import { selectSelectedTeam, selectUserFormData } from "app/redux/selector";
import { actions as appActions } from "app/redux/slice";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";
import LastActivitiesWidget from "./components/LastActivitiesWidget";
import MyTicketsTable from "./components/MyTicketsTable";
import ProjectsProgressWidget from "./components/ProjectsProgressWidget";
import TicketStatusWidget from "./components/TicketStatusWidget";
import homeSaga from "./redux/saga";
import { actions, homeReducer, homeSliceName } from "./redux/slice";

export default function Homepage() {
  useInjectReducer({ key: homeSliceName, reducer: homeReducer });
  useInjectSaga({ key: homeSliceName, saga: homeSaga });

  const dispatch = useDispatch();
  const selectedTeam = useSelector(selectSelectedTeam);
  const { selectedProjectId } = useSelector(selectUserFormData);

  useEffect(() => {
    if (selectedProjectId) {
      dispatch(appActions.fetchProjectSettings(selectedProjectId));
    }
    return () => {};
  }, [selectedProjectId, dispatch]);

  useEffect(() => {
    dispatch(actions.setChartLoading(true));
    dispatch(actions.setActivitiesLoading(true));
    if (selectedTeam?._id) {
      dispatch(actions.getChartData());
    }

    return () => {
      dispatch(actions.resetHomeState());
    };
  }, [dispatch, selectedTeam?._id]);

  return (
    <div className="flex h-[calc(100vh-70px)] w-full flex-col overflow-y-auto min-h-0">
      <div className="mx-auto flex min-h-full w-full max-w-[calc(100vw-64px)] flex-col">
        <div className="flex min-h-0 w-full flex-1 flex-col gap-4 px-6 py-4">
          <div className="flex items-center gap-2">
            <HomeIconV2 size={16} />
            <h1 className="text-[14px] font-medium text-black">Home</h1>
          </div>

          <div className="flex gap-4">
            <div className="flex min-w-0 flex-1 flex-col gap-4">
              <TicketStatusWidget />
              <ProjectsProgressWidget />
            </div>

            <div className="flex min-w-0 flex-1">
              <LastActivitiesWidget />
            </div>
          </div>

          <MyTicketsTable />
        </div>
      </div>
    </div>
  );
}
